<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Performance Results</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        <span class="configurationInput">
          <span class="configurationInputLabel">Airflow:</span>
          <input readonly="readonly" [value]="airflow" class="configurationRatingValueOutput" />
          <span class="configurationRatingUnitLabel">{{ getAirflowMeasurementUnits(false) }}</span>
        </span>
        <span class="configurationInput">
          <span class="configurationInputLabel">Power:</span>
          <input readonly="readonly" [value]="outputPower" class="configurationRatingValueOutput" />
          <span class="configurationRatingUnitLabel">Watts</span>
        </span>
        <span class="configurationInput">
          <span class="configurationInputLabel">FLA:</span>
          <input readonly="readonly" [value]="fullLoadAmps" class="configurationRatingValueOutput" />
        </span>
      </div>
      <div class="configurationDetailRow">
        <span class="configurationInput">
          <span class="configurationInputLabel">Standard Airflow:</span>
          <input readonly="readonly" [value]="standardAirflow" class="configurationRatingValueOutput" />
          <span class="configurationRatingUnitLabel">{{ getAirflowMeasurementUnits(true) }}</span>
        </span>
        @if (controlVoltage > 0) {
          <span class="configurationInput">
            <span class="configurationInputLabel">Control Voltage:</span>
            <input readonly="readonly" [value]="controlVoltage" class="configurationRatingValueOutput" />
            <span class="configurationRatingUnitLabel">V</span>
          </span>
        }
      </div>
      <app-performance-results [ratingResponse]="ratingResponse()" [isMetric]="isMetric" [isSureflow]="isSureflow()"></app-performance-results>
    </div>
  }
</div>
